import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const selectedSchemasState = atom<Guid[]>({
  key: 'SelectedSchemasState',
  default: [],
  effects: []
});
